<template>
	<v-container fluid id="consultas-container" class="d-flex flex-column">
		<v-btn-toggle style="width: 100%;" v-if="!$vuetify.breakpoint.mobile">
			<GlobalNewButton class="mr-2"/>
			<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 2 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_tasks_listing'])"
				@click="changeListing(2)">
				<div class="d-flex align-start">
					<v-icon>mdi-file-document-multiple-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Mis Tareas</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Participante</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 3 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_tasks_listing'])"
				@click="changeListing(3)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Todas</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 4 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_tasks_listing'])"
				@click="changeListing(4)">
				<div class="d-flex align-start">
					<v-icon>mdi-text-box-check-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Finalizadas</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Todas</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 5 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_tasks_listing'])"
				@click="changeListing(5)">
				<div class="d-flex align-start">
					<v-icon>mdi-account-group-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Por Usuario</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 7 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_tasks_listing'])"
				@click="changeListing(7)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-column-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Kanban</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Tablero</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 6 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_tasks_listing'])"
				@click="changeListing(6)">
				<div class="d-flex align-start">
					<v-icon>mdi-file-document-edit-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
					</div>
				</div>
			</v-btn>
			<v-menu v-model="searchMenu" :offset-y="true" style="z-index:11" :close-on-content-click="false" contentClass="custom-content-search elevation-0">
				<template v-slot:activator="{ on, attrs }">
					<v-btn text class="d-flex pa-0 justify-center" style="height: auto;"
						v-bind="attrs"
						v-on="on">
						<v-badge
							v-if="$store.consultasStore.state.searchFilter && $store.consultasStore.state.searchFilter != ''"
							class="animate__animated animate__tada animate__infinite"
							color="success"
							icon="mdi-magnify-expand"
							light
						>
								<v-icon color="#5e85ef" class="ml-1">mdi-magnify</v-icon>
						</v-badge>
						<v-icon v-else color="#5e85ef" class="ml-1">mdi-magnify</v-icon>
					</v-btn>
				</template>
				<v-text-field
						outlined
						clearable
						dense
						rounded
						hide-details
						label="Búsqueda por título"
						type="text"
						class="search-input"
						v-model="searchInput"
						@keydown="sendToSearch"
						@click:clear="sendToSearchClickClear"
					>
						<template v-slot:append>
							<v-btn
								class="search-button elevation-0"
								fab
								dark
								small
								color="#5E85EF"
								@click="sendToSearchClick"
							>
								<v-icon dark>mdi-magnify</v-icon>
							</v-btn>
						</template>
						<template v-slot:label>
							<p class="mb-0 ml-5 caption">Búsqueda por título</p>
						</template>
				</v-text-field>
			</v-menu>
		</v-btn-toggle>
    <v-menu offset-y v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
					rounded
					color="#2D4B95"
					dark
					small
					block
          v-bind="attrs"
          v-on="on"
        >
          Seleccione Acción
        </v-btn>
      </template>
			<div class="d-flex flex-column pa-2 white" style="gap: 5px;">
				<GlobalNewButton :fullWidth="true"/>
				<v-divider class="my-1"></v-divider>
				<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 2 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_tasks_listing'])"
					@click="changeListing(2)">
					<div class="d-flex align-start">
						<v-icon>mdi-file-document-multiple-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Mis Tareas</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Participante</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 3 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_tasks_listing'])"
					@click="changeListing(3)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Todas</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 4 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_tasks_listing'])"
					@click="changeListing(4)">
					<div class="d-flex align-start">
						<v-icon>mdi-text-box-check-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Finalizadas</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Todas</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 5 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_tasks_listing'])"
					@click="changeListing(5)">
					<div class="d-flex align-start">
						<v-icon>mdi-account-group-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Por Usuario</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 7 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_tasks_listing'])"
					@click="changeListing(7)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-column-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Kanban</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Tablero</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.consultasStore.state.selectedType === 6 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_tasks_listing'])"
					@click="changeListing(6)">
					<div class="d-flex align-start">
						<v-icon>mdi-file-document-edit-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
						</div>
					</div>
				</v-btn>
			</div>
    </v-menu>
		<div v-if="checkPermissions(['view_tasks_listing'])">
			<MisTareas v-if="this.$store.consultasStore.state.selectedType === 2"/>
			<ListadoConsultas
				ref="listadoConsultas"
				v-if="(this.$store.consultasStore.state.selectedType === 3 || this.$store.consultasStore.state.selectedType === 4) && !$vuetify.breakpoint.mobile"
				:ended="this.$store.consultasStore.state.selectedType === 4"
			/>
			<ListadoConsultasMobile
				ref="listadoConsultas"
				v-if="(this.$store.consultasStore.state.selectedType === 3 || this.$store.consultasStore.state.selectedType === 4) && $vuetify.breakpoint.mobile"
				:ended="this.$store.consultasStore.state.selectedType === 4"
			/>
			<TareasByUser v-if="this.$store.consultasStore.state.selectedType === 5" />
			<ListadoBorradores
				v-if="this.$store.consultasStore.state.selectedType === 6"
				:draftType="1"
				@loadDraft="loadDraft"
			/>
			<KanbanView v-if="this.$store.consultasStore.state.selectedType === 7" />
		</div>
		<div v-else class="d-flex flex-column align-center justify-center" style="height: 100%;min-height: 300px;">
			<v-icon size="50" color="grey lighten-1">mdi-lock</v-icon>
			<p class="text-center mt-2 mb-0 text--grey">No tienes permisos para ver las tareas.</p>
			<p class="text-center caption text--grey">Contacta con el administrador del proyecto.</p>
		</div>
	</v-container>
</template>

<script>
import MisTareas from './MisTareas'
import ListadoConsultas from './ListadoConsultas'
import ListadoConsultasMobile from './ListadoConsultasMobile'
import ListadoBorradores from '@/components/Globals/Helpers/ListadoBorradores'
import TareasByUser from './TareasByUser'
import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'
import KanbanView from './Kanban/KanbanView'
import { getTareaByID } from '@/helpers/api/tasks'

// import {list} from '@/helpers/api/tasks'
export default {
	name: 'ConsultasContainer',
	components: {MisTareas, ListadoConsultas, ListadoBorradores, ListadoConsultasMobile, TareasByUser, GlobalNewButton, KanbanView},
	data: () => ({
		searchInput: null,
		searchMenu: false,
		createTareaModal: false,

	}),
	computed: {
		selectedProject(){
			return this.$store.projectsStore.state.selectedProject
		}
	},
	watch: {
		selectedProject(newVal, oldVal){
			if(!newVal?.id || newVal.id === oldVal?.id) return
			this.searchInput = null
			this.getTaskCodes()
			this.getConsultasList()
			this.loadCurrentListing()
		}
	},
	mounted(){
		if(this.$store.consultasStore.state.taskCodes.length === 0){
			this.getTaskCodes()
		}
		this.loadCurrentListing()
	},
	methods: {
		async loadCurrentListing(){
			if(this.$store.consultasStore.state.selectedType === 3 || this.$store.consultasStore.state.selectedType === 4){
				await this.$nextTick()
				const listRef = this.$refs.listadoConsultas
				if(listRef && typeof listRef.getConsultasList === 'function'){
					listRef.getConsultasList()
				}
			}
		},
		loadDraft(draft){
			const draftType = draft.raw_type
			
			if(draftType === 1) {
				this.$store.consultasStore.commit('setDraftToLoad', draft)
				this.$store.consultasStore.commit('setCreateTareaModal', true)
			}
			else if(draftType === 5) {
				this.$store.consultasStore.commit('setDraftToLoad', draft)
				this.viewTarea(draft.morphable_id)
			}
		},
		async viewTarea(task_id){
			this.$store.consultasStore.commit('setCurrentTarea', {loading: true})
			const tarea = await getTareaByID({task_id})
			if(tarea.code === 200){
				let tareaData = tarea.task
				this.$store.consultasStore.commit('setCurrentTarea', tareaData)
			}
		},
		sendToSearch(event){
      if (event.keyCode === 13) { 
				this.$store.consultasStore.commit('setSearchFilter', this.searchInput)
				this.searchMenu = false
      }
		},
		sendToSearchClick(){
			this.$store.consultasStore.commit('setSearchFilter', this.searchInput)
			this.searchMenu = false
		},
		sendToSearchClickClear(){
			this.searchInput = null
			this.searchMenu = false
			this.$store.consultasStore.commit('setSearchFilter', this.searchInput)
		},
		async getTaskCodes(){
			const project_id = this.$store.projectsStore.state.selectedProject?.id
			if(project_id){
				this.$store.consultasStore.dispatch('getTaskCodes', {project_id})
			}
		},
		async changeListing(selected){
			if(this.$store.consultasStore.state.selectedType != selected){
				this.$store.consultasStore.commit('setSelectedType', selected)
				await this.$nextTick()

				const listRef = this.$refs.listadoConsultas
				if(listRef && typeof listRef.getConsultasList === 'function'){
					listRef.getConsultasList()
				}
				else if(selected == 5){
					this.getConsultasList()
				}
			}
		},
		async getConsultasList(){
			let project_id = null
			if(this.$store.projectsStore.state.selectedProject){
				project_id = this.$store.projectsStore.state.selectedProject.id
			}
			else{
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if(project_id){
				this.$store.consultasStore.dispatch('getMyTasks', {
							project_id,
							search: this.searchInput
						})
			}
		}
	}
};
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
		text-align: left;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}
	.custom-content-search{
		background-color: transparent;
		padding-top: 7px;
		width: 400px;
	}
	.search-input{
		position: relative;
		background-color: white;
		border-color: red;
		z-index:11;
	}
	/deep/ .search-input input{margin-left: 20px;}
	.search-button{
		position: absolute;
		top: 0;
		left: 0;
		z-index: 2;
	}
	.search-container{
		position: absolute;
		width: 400px;
		z-index: 999;
	}
</style>
